import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import AuthService from "../../Service/auth.service";
import { User } from "../../Entities/User";

interface AuthContextProps {
  isUserLoggedIn: boolean;
  user: User | null;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState<boolean>(false);
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    AuthService.getInstance().subscribe(
      AuthService.EVENTS.USER_SIGNED_IN,
      () => {
        setIsUserLoggedIn(true);
        setUser(AuthService.getInstance().getCurrentUser());
      }
    );
    const user = AuthService.getInstance().getCurrentUser();
    setIsUserLoggedIn(!!user);
    AuthService.getInstance().subscribe(
      AuthService.EVENTS.USER_SIGNED_OUT,
      () => {
        setIsUserLoggedIn(false);
        setUser(null);
      }
    );
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isUserLoggedIn,
        user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
